import React from 'react';
import Header from "../../User/layouts/Header";
import "../styles/pages/home.scss";
import { List, ListItem, Typography, Container } from '@mui/material';
import place_order from '../../User/assets/icons/place-order.svg';
import meet_designer from '../../User/assets/icons/meet-design.svg';
import pickup_order from '../../User/assets/icons/pickup-order.svg';
import stitch from '../../User/assets/icons/stitch-icon.svg';
import delivery_icon from '../../User/assets/icons/deliver-icon.svg'
import WhatsApp from "../../User/components/WhatsApp";
import Footer from '../layouts/Footer';
import StepProgress from '../components/StepProgress';


const Aboutus = () => {
    //     const phrases = [
    //   "Book Your Designer",
    //   "Explore Our Designs",
    //   "You Design We Stitch",
    // ];
    // const repeatedPhrases = [...Array(20)].flatMap(() =>
    //     phrases.map((text, index) => (
    //         <span className="scroll-content" key={`${text}-${index}-${Math.random()}`}>
    //             {text}
    //             <span className="star"> ✦ </span>
    //         </span>
    //     ))
    // );
    return (
        <React.Fragment>
            <Header />
            <section className='about'>
                <Typography variant='h4'>About Us</Typography>
            </section>
            <section className='about-text'>
                <Container maxWidth="xl">
                    <div className='about-content'>
                        <Typography variant="h5" style={{ color: ' #e37b00' }}>
                            Currently, we are delivering only within Hyderabad.
                        </Typography>
                        <Typography>We, at Tailors4U aim at providing Tailoring and Fashion solutions to everyone in the most convenient way without compromising on quality of the service, with Experienced Designers, Masters and Tailors on board.</Typography>
                        <Typography variant='h5'>Mission :</Typography>
                        <Typography>To be One-Stop solution provider for all the Tailoring & fashion needs of Customers irrespective of Gender and Age.</Typography>
                        <Typography variant='h5'>How it Works?</Typography>
                        <ul>
                            <li>Place order through our App</li>
                            <li>Schedule Designer Home-Consultation within Hyderabad at Rs.500, which will be adjusted in the final bill. Enjoy Our Designer Consultation free of cost at the comfort of your home. We pick up your fabric and stitch at our workshop.</li>
                            <li>Please note that Home-Consultation is available in Hyderabad only at the moment and we provide Online Consultation over Video call within and outside Hyderabad.</li>
                            <li>Your favourite product will be delivered by our Designer that can be tried and altered at no extra cost within 3 days of delivery.</li>
                        </ul>
                    </div>
                    {/* <div className='about-order'>
                        <List>
                            <ListItem><img src={place_order} alt='place_order' />Place Order</ListItem>
                            <ListItem><img src={meet_designer} alt='meet_designer' />Meet Your Designer</ListItem>
                            <ListItem><img src={pickup_order} alt='pickup_order' />Pickup/Procure</ListItem>
                            <ListItem><img src={stitch} alt='stitch' />Stitch</ListItem>
                            <ListItem><img src={delivery_icon} alt='delivery_icon' />Delivered</ListItem>
                        </List>
                    </div> */}

                    <section>
                        <StepProgress />
                    </section>
                </Container>
            </section>
            <WhatsApp />
            <React.Fragment>
                <Footer />
            </React.Fragment>
        </React.Fragment>
    )
}

export default Aboutus;